<!--
 * @FileDescription: Sku信息展示Two
 * @Author: 陈文景
 * @Date: 2022-11-07 14:39:49
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="sku-info">
    <div class="info">
      <p class="top">
        <span class="sku-code">
          <span>
            <span>公司SKU：</span>
            <span v-if="data.errorCode" class="error">{{ dafaultTips(data.errorCode) }}</span>
            <span v-else>{{ dafaultTips(data.skuCode) }}</span>
          </span>
        </span>
        <span class="seller-sku">Seller SKU：{{ dafaultTips(data.sellerSku) }}</span>
      </p>

      <div class="bottom">
        <div class="img-info">
          <img :src="data.imgUrl" alt="img.png" />
          <div class="info-item">
            <p class="title">{{ dafaultTips(data.productName) }}</p>
            <p class="size">{{ dafaultTips(data.options) }}</p>
            <p class="price">${{ dafaultTips(data.skuTotalAmount) }}</p>
          </div>
        </div>
        <div class="money-info">
          <span class="money">{{ `$${dafaultTips(data.price)}` }}</span>
          <span class="ride">X</span>
          <span class="sum">{{ dafaultTips(data.qty) }}</span>
        </div>
        <div class="total-money">US ${{ dafaultTips(data.skuTotalAmount) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    dafaultTips() {
      return (value) => value || '-'
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.sku-info {
  padding: 15px 0;
  border-bottom: 1px solid #f5f7f7;
  .info {
    flex: 1;
    .top {
      color: #747a87;
      font-size: 13px;
      margin-bottom: 10px;
      .sku-code {
        position: relative;
        margin-right: 26px;
        .error {
          color: #f56c6c;
        }
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      .img-info {
        flex: 1;
        display: flex;
        height: 100%;
        img {
          width: 70px;
          height: 72px;
          font-size: 12px;
          object-fit: cover;
          border-radius: 4px;
          border: 1px solid rgba(204, 211, 217, 1);
        }
        .info-item {
          flex: 1;
          display: flex;
          color: #10141d;
          font-size: 14px;
          font-weight: 400;
          margin-left: 10px;
          flex-direction: column;
          justify-content: space-between;
          .title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
      .money-info {
        position: relative;
        display: flex;
        width: 120px;
        align-items: center;
        margin: 0 15px;
        .money {
          color: #10141d;
          font-size: 16px;
          font-weight: 500;
        }
        .ride {
          font-size: 12px;
          margin: 0 5px;
        }
        .sum {
          font-size: 14px;
        }
      }
      .total-money {
        display: flex;
        width: 120px;
        align-items: center;
        font-size: 16px;
      }
    }
  }
}
</style>
